import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Url } from '@environment';
import { map } from 'rxjs/operators';
import { RequestHandlerService } from 'src/app/core/services/request-handler/request-handler.service';
import { IFeatureVars, IFeatureVarsResponseMap } from '../../interfaces/feature-vars.interface';

@Injectable({
    providedIn: 'root'
})
export class FeatureVarsService {

    constructor(
        private requestHandler: RequestHandlerService,
        private http: HttpClient
    ) { }

    /**
     * @param codigo Codigo de la variable de características a obtener. Ej: 'CHATBOT_ASESOR_V2_CONFIG'
     * @returns Objecto con las variables asociadas mapeadas por su código. Ej: { TERMINOS_CONDICIONES: {...}, HABILITAR_SUBIDA_DOCUMENTOS_CHATBOT_V2: {...} }
     */
    get(codigo: string): Promise<IFeatureVarsResponseMap | null> {
        const url = `${Url}/transversal/feature-vars`;
        return this.http.get(url, { params: { codigo } }).pipe(
            map((resp: any) => {
                const data = resp.data?.[0];
                if (data?.codigo !== codigo) return;
                const subFeatures = data?.subFeatureVars || [];
                return subFeatures.reduce((acc: IFeatureVarsResponseMap, subFeature: IFeatureVars) => {
                    acc[subFeature.codigo] = subFeature;
                    return acc;
                }, {});
            })
        ).toPromise();
    }

    async obtener(detalleCategoria?: string, idCategoria?: string, codigoVariable?: string) {

        try {
            let query = idCategoria ? `codigoCategoria=${idCategoria}` : '';
            query = codigoVariable ? `&codigo=${codigoVariable}` : ''
            query = detalleCategoria ? `&detalleCategoria=${detalleCategoria}` : ''
            const url = `${Url}/transversal/feature-vars?${query}`;
            return await this.requestHandler.doGet<any>(url);
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getMapped(input: any): Promise<any> {
        const obj = {};
        try {
            const { detalleCategoria, idCategoria, codigoVariable } = input;
            const items: any = await this.obtener(detalleCategoria, idCategoria, codigoVariable);
            const vars = items.data ?? [];
            for (const vr of vars) {
                const svars = vr.subFeatureVars ?? [];
                vr.svrs = {};
                for (const svr of svars) {
                    vr.svrs[svr.codigo] = svr;
                }
                obj[vr.codigo] = vr;
            }
            return obj;
        } catch (err) {
            return obj;
        }
    }
}
